import React from 'react';
import PropTypes from 'prop-types';

const POILogo = (props) => {

  return (
    <div className="sk-hits-list-hit__logo">
      <img alt={props._source.name} src={props._source.logo_url} />
    </div>
  );
};

POILogo.propTypes = {
  _source: PropTypes.shape({
    name: PropTypes.string.isRequired,
    logo_url: PropTypes.string
  })
};

export default POILogo;



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/searchBox/POIListItems/POILogo.jsx